import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getResults as getResultsAction } from '../reducers/actions';
import { FORM_RESPONSES_KEY } from '../constants/storageKeys';

const SubmitHelper = () => {
  const dispatch = useDispatch();
  const form = useSelector(state => state.form);

  const handleClick = () => {
    // Store form responses for retrieval on the PreSubmitInfo page if
    // the user wants to edit them after navigating from the results page.
    sessionStorage.setItem(FORM_RESPONSES_KEY, JSON.stringify(form.data));

    dispatch(getResultsAction(form.data));
  };

  return (
    <div
      id="submit-helper"
      visible="false"
      aria-hidden="true"
      onClick={handleClick}
      onKeyDown={() => {}}
    />
  );
};

export default SubmitHelper;
